<h3>{{ "HängigeGbgeschäfte" | translate }}</h3>

<cap-list-loader [hasRight]="hasRight" [listLoader]="haengigeLoader">
  <div class="cap-list-loader-content">
    <table [attr.aria-label]="'HängigeGbgeschäfte' | translate" class="cap-table-detail">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th class="noselect" style="cursor: pointer; width: 15%">
      <cap-column-header [columnName]="'Tagebuchnummer'" [sortModel]="tableSortModel.columns.get('tagebuchnummer')"></cap-column-header>
    </th>
    <th class="noselect" style="cursor: pointer; width: 10%">
      <cap-column-header [columnName]="'Eingang'" [sortModel]="tableSortModel.columns.get('eingangTagebuch')"></cap-column-header>
    </th>
    <th class="noselect" style="width: 25%">
      {{ "Beschreibung" | translate }}
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (geschaeft of haengigeLoader?.items; track geschaeft.id.id) {
    <tr>
      <td>
        <cap-kompakt-grundbuchgeschaeft [item]="geschaeft" [mitLinkGeschaeft]="false"></cap-kompakt-grundbuchgeschaeft>
      </td>
      <td>
        <cap-link [enableNavigation]="false" [params]="[geschaeft.id.id]" [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
          {{ geschaeft.eingangTagebuch | datum }}
        </cap-link>
      </td>
      <td>
        @if (geschaeft.mBeschreibung.access !== "NONE") {
          <span>
            <cap-link [enableNavigation]="false" [params]="[geschaeft.id.id]" [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
              {{ geschaeft.beschreibung }}
            </cap-link>
          </span>
        }
        @if (geschaeft.mBeschreibung.access === "NONE") {
          <span>{{"gemaessGrundbuch" | translate}}</span>
        }
      </td>
    </tr>
  }
</ng-template>
